import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiQuery } from 'store/query';
import { generateUrl } from 'utils/helpers';
const tagType = 'Breeds Bitwerx';
import { Utils } from '@gv/triage-components';

export const bitwerxPetDetailAPI = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'bitwerxPetDetailAPI',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data,
      query: (data: any) => ({
        method: 'get',
        url: Utils.Query.addParamsToUrl(
          generateUrl(URL.GET_BITWERX_PET_DETAIL, {
            id: data?.id,
            client_id: data?.clientId,
          }),
          {
            hospitalId: data.hospitalId,
          }
        ),
      }),
    }),
  }),
});

export const { useListQuery } = bitwerxPetDetailAPI;
